/* Pop-ups d'entrée et de sortie — NTech, 24/10/2026. Voir sections/ntx-popups.liquid. */
(function () {
  'use strict';
  var OS = 'https://app.ntechperf.com';
  var CLE = 'ntx_porte';          // mémoire partagée avec la porte du configurateur : {email, cid, t}
  var CLE_ENTREE = 'ntx_pop_entree'; // dernier affichage (ms)
  var CLE_SORTIE = 'ntx_pop_sortie';
  /* ⭐ 28/10 — même mesure que la porte (voir ntx-porte-configurateur.js) : vue, email,
     fermee, par surface (entrée, sortie, rappel). Identifiant d'onglet aléatoire, haché
     côté serveur ; ni adresse, ni IP. */
  var CLE_SID = 'ntx_sid';
  function sid() {
    try {
      var v = sessionStorage.getItem(CLE_SID);
      if (!v) {
        v = (window.crypto && crypto.randomUUID ? crypto.randomUUID().replace(/-/g, '')
          : String(Date.now()).slice(-10) + Math.random().toString(36).slice(2, 12)).slice(0, 32);
        sessionStorage.setItem(CLE_SID, v);
      }
      return v;
    } catch (e) { return null; }
  }
  function mesurer(quoi, etat, D) {
    var s = sid(); if (!s) return;
    var corps = JSON.stringify({ quoi: quoi, etat: etat, sid: s,
      handle: (D && D.handle) || null, locale: (D && D.locale) || null, pays: (D && D.pays) || null });
    try {
      if (navigator.sendBeacon) { navigator.sendBeacon(OS + '/api/site/porte', new Blob([corps], { type: 'text/plain' })); return; }
    } catch (e) {}
    try { fetch(OS + '/api/site/porte', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: corps, keepalive: true }).catch(function () {}); } catch (e) {}
  }
  function surface(v) { return v === 'sortie' ? 'popup_sortie' : v === 'connu' ? 'popup_connu' : 'popup_entree'; }

  function lire(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function ecrire(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function jours(ms) { return ms * 864e5; }
  function robot() { return /bot|crawl|spider|slurp|preview|lighthouse|headless/i.test(navigator.userAgent); }

  function init() {
    var pop = document.getElementById('ntx-popups');
    if (!pop || robot()) return;
    var D = pop.dataset;
    // Mémoire UNIFIÉE avec le relais (banner.js) : son jeton `bb_nt_cid` vaut adresse connue.
    var connu = function () { var e = lire(CLE); if (e && e.email) return true; try { return !!localStorage.getItem('bb_nt_cid'); } catch (x) { return false; } };
    var porteOuverte = function () { var p = document.getElementById('ntx-porte'); return !!(p && !p.hidden); };
    var visage = null, ouvert = false, envoye = false;

    function montrer(v) {
      pop.querySelectorAll('[data-v]').forEach(function (el) { el.hidden = el.dataset.v.split(' ').indexOf(v) === -1; });
    }
    function ouvrir(v) {
      if (ouvert || porteOuverte()) return;
      visage = v; ouvert = true; montrer(v === 'connu' ? 'connu' : v);
      pop.hidden = false; pop.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden';
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'ntx_popup', visage: v }); } catch (e) {}
      mesurer(surface(v), 'vue', D);
      if (v !== 'connu') setTimeout(function () { var c = pop.querySelector('input[name="email"]'); if (c) c.focus(); }, 80);
    }
    var fermer = function () {
      // ⚠️ `envoye` : après « merci », la fermeture automatique n'est pas un abandon.
      if (ouvert && !envoye) mesurer(surface(visage), 'fermee', D);
      pop.hidden = true; pop.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; ouvert = false; envoye = false;
    };
    pop.addEventListener('click', function (ev) { if (ev.target.closest('[data-ntx-pop-fermer]')) fermer(); });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && ouvert) fermer(); });

    // ── LA LOGIQUE GLOBALE (Arthur, 24/10) :
    //   · part tout de suite → la SORTIE s'affiche même si l'entrée n'a pas eu lieu ;
    //   · sortie fermée sans e-mail → l'ENTRÉE pourra venir plus tard dans la session (jamais
    //     deux pop-ups à moins de `ecartSecondes`, jamais deux ouverts à la fois) ;
    //   · adresse donnée (entrée OU sortie) → l'entrée ne revient jamais, et la sortie devient
    //     le RAPPEL du code (« valable jusqu'au … »), au plus toutes les `rappelMinutes` ;
    //   · adresse donnée à la PORTE (sans code) → rappel sans date : sa configuration est gardée.
    var ecart = Number(D.ecartSecondes || 45) * 1000, rappelMs = Number(D.rappelMinutes || 10) * 60000, codeJours = Number(D.codeJours || 14);
    var dernierFerme = 0;
    var ancienFermer = fermer;
    fermer = function () { ancienFermer(); dernierFerme = Date.now(); };
    // La bannière de consentement (relais, #bb-consent) passe AVANT tout : on ne parle pas par-dessus.
    // ⛔ 26/10 : la bannière peut porter `bb-show` sans être à l'écran (marchés sans
    // consentement, bannière repliée) — on regarde ce qui est VRAIMENT affiché, sinon
    // aucun pop-up ne sort jamais : zéro adresse par la sortie en trois jours.
    function consentementVisible() {
      // ⚠️ la bannière est en position:fixed : son offsetParent est TOUJOURS null, on mesure
      // sa boîte plutôt que de s'y fier.
      var c = document.querySelector('#bb-consent.bb-show');
      if (!c) return false;
      var r = c.getBoundingClientRect(), st = getComputedStyle(c);
      return r.height > 0 && st.display !== 'none' && st.visibility !== 'hidden';
    }
    function libre() { return !ouvert && !porteOuverte() && !consentementVisible() && Date.now() - dernierFerme > ecart; }

    var dernierEntree = lire(CLE_ENTREE) || 0, dernierSortie = lire(CLE_SORTIE) || 0;
    var entreeVue = false, sortieInconnueVue = false, dernierRappel = 0;

    // Entrée : temps OU défilement, une fois par 30 j, jamais si l'adresse est connue, plus tard si la sortie vient de parler.
    if (D.entree === 'true' && !connu() && Date.now() - dernierEntree > jours(Number(D.entreeJours || 30))) {
      var voulue = false, seuil = Number(D.defilement || 40) / 100;
      var tenterEntree = function () {
        if (entreeVue || connu()) return;
        if (!libre()) { setTimeout(tenterEntree, 3000); return; }   // la sortie est ouverte ou vient de se fermer : on repasse
        entreeVue = true; ecrire(CLE_ENTREE, Date.now()); ouvrir('entree');
      };
      var demanderEntree = function () { if (!voulue) { voulue = true; tenterEntree(); } };
      setTimeout(demanderEntree, Number(D.delai || 15) * 1000);
      window.addEventListener('scroll', function onScroll() {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && window.scrollY / h >= seuil) { window.removeEventListener('scroll', onScroll); demanderEntree(); }
      }, { passive: true });
    }

    // Sortie : intention de départ, dès 2 s (quelqu'un qui repart aussitôt est précisément celui qu'on veut retenir).
    if (D.sortie === 'true') {
      var armeeApres = Date.now() + 2000;
      var allerSortie = function () {
        if (Date.now() < armeeApres || ouvert || porteOuverte() || consentementVisible()) return;
        var e = lire(CLE);
        if (connu()) {
          // Adresse connue : le rappel, au plus toutes les N minutes.
          if (Date.now() - dernierRappel < rappelMs) return;
          dernierRappel = Date.now(); preparerConnu(e); ouvrir('connu');
          return;
        }
        if (sortieInconnueVue || Date.now() - dernierSortie <= jours(Number(D.sortieJours || 7))) return;
        if (Date.now() - dernierFerme < ecart) return;
        sortieInconnueVue = true; ecrire(CLE_SORTIE, Date.now()); ouvrir('sortie');
      };
      document.addEventListener('mouseout', function (ev) { if (!ev.relatedTarget && ev.clientY <= 0) allerSortie(); });
      if (D.sortieMobile === 'true' && matchMedia('(pointer: coarse)').matches) {
        try { history.pushState({ ntxPop: 1 }, ''); window.addEventListener('popstate', function () { allerSortie(); }); } catch (e) {}
        var dernierY = window.scrollY, dernierT = Date.now();
        window.addEventListener('scroll', function () {
          var y = window.scrollY, t = Date.now();
          if (dernierY - y > 600 && t - dernierT < 500 && y < 200) allerSortie();
          dernierY = y; dernierT = t;
        }, { passive: true });
      }
    }
    function preparerConnu(e) {
      // La date de validité du code — seulement si l'adresse est venue d'un pop-up (la porte ne promet pas de code).
      var el = pop.querySelector('[data-ntx-pop-code]');
      if (el) {
        if (e && e.offre) {
          var fin = new Date(e.offre + codeJours * 864e5);
          var date = fin.toLocaleDateString(document.documentElement.lang || D.locale || 'fr', { day: 'numeric', month: 'long' });
          var cible = el.querySelector('[data-ntx-pop-code-texte]') || el;
          cible.textContent = (el.dataset.modele || '').replace('{date}', date); el.hidden = false;
        } else el.hidden = true;
      }
      // Le bouton « reprendre » vise le panier s'il n'est pas vide, sinon la page produit courante, sinon la boutique.
      var a = pop.querySelector('[data-ntx-pop-reprise]'); if (!a) return;
      var handle = D.handle || '';
      fetch(D.cartJson || '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { a.href = (c && c.item_count > 0) ? (D.cartUrl || '/cart') : (handle ? location.pathname : (D.cartUrl || '/')); })
        .catch(function () {});
    }

    // ── Envoi : l'adresse part vers NTech OS, qui crée le code et envoie l'e-mail de bienvenue.
    var form = pop.querySelector('form'), champ = form.querySelector('input[name="email"]'), hp = form.querySelector('input[name="hp"]');
    var erreur = form.querySelector('.ntx-pop__erreur'), bouton = form.querySelector('.ntx-pop__bouton');
    form.addEventListener('submit', function (ev) {
      ev.preventDefault(); erreur.hidden = true;
      var email = (champ.value || '').trim().toLowerCase();
      if (!/^[^\s@]{1,64}@[^\s@]{1,255}\.[a-z]{2,24}$/i.test(email)) { erreur.textContent = erreur.dataset.errEmail; erreur.hidden = false; champ.focus(); return; }
      bouton.disabled = true;
      envoye = true; mesurer(surface(visage), 'email', D);
      var corps = { email: email, source: visage === 'sortie' ? 'popup_sortie' : 'popup_entree', handle: D.handle || null, locale: D.locale || null, pays: D.pays || null, hp: hp ? hp.value : '' };
      fetch(OS + '/api/site/prospect', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(corps), keepalive: true })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)); })
        .then(function (d) {
          var e = lire(CLE) || {}; var cid = (d && d.cid) ? String(d.cid) : (e.cid || null);
          ecrire(CLE, { email: email, cid: cid, t: Date.now(), offre: Date.now() });
          if (cid) { try { localStorage.setItem('bb_nt_cid', cid); } catch (x) {} }   // le relais (banner.js) s'en sert pour envoyer la configuration à l'ajout au panier
          if (typeof fbq !== 'undefined') { try { fbq('track', 'Lead', { content_name: 'popup_' + (visage || 'entree') }); } catch (x) {} }
          bouton.disabled = false; montrer('merci'); setTimeout(fermer, 3500);
        })
        .catch(function () { bouton.disabled = false; erreur.textContent = erreur.dataset.errEnvoi; erreur.hidden = false; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
